const ERROR_FORM_TYPES = {
  ALREADY_EXISTS: 'already_exists',
};

module.exports = {
  ERROR_FORM_TYPES,
};
